import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() title: string;
  @Input() icon: string;
  @Input() fontSize: number;
  @Input() customColor: string;
  @Input() inverz = false;
  @Input() fullWidth = false;
  @Input() disabled = false;
  size = '20px';
  font = '16px';

  ngOnInit() {
    if (this.fontSize) {
      this.size = `${this.fontSize}px`;
      this.font = `${this.fontSize - 4}px`;
    }
  }
}
